
<ng-container *ngFor="let filter of filters; let index = index">
  <div 
  class="flex flex-col mb-4"
  [ngClass]="{'hidden': isLoading}"
  >
      <ng-template [ngTemplateOutlet]="dataContent" [ngTemplateOutletContext]="{ filter: filter, index: index }"></ng-template>
  </div>
</ng-container>

<ng-template #dataContent let-filter="filter" let-index="index">
        <svc-text
          *ngIf="filter.type == 'text'"
          [svcTestId]="filter.svcTestId"
          class="w-full"
          [label]="filter.label"
          [formControl]="controls[index]"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
        ></svc-text>

        <svc-text-area
          *ngIf="filter.type == 'textarea'"
          [svcTestId]="filter.svcTestId"
          class="w-full"
          [label]="filter.label"
          [formControl]="controls[index]"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
        ></svc-text-area>

        <svc-select
          *ngIf="filter.type == 'select'"
          [svcTestId]="filter.svcTestId"
          class="w-full"
          [label]="filter.label"
          [formControl]="controls[index]"
          [options]="filter.config?.options"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
        ></svc-select>

        <svc-date-picker
          *ngIf="filter.type == 'date'"
          [svcTestId]="filter.svcTestId"
          class="w-full"
          [label]="filter.label ?? null"
          [formControl]="controls[index]"
          [min]="filter.config?.minDate"
          [max]="filter.config?.maxDate"
          [format]="filter.config?.format"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
        ></svc-date-picker>

        <svc-chip
          *ngIf="filter.type == 'chip'"
          [svcTestId]="filter.svcTestId"
          class="w-full"
          [label]="filter.label"
          [formControl]="controls[index]"
          [options]="filter.config?.options"
          [type]="filter.config?.chipType ?? 'multiple'"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
        ></svc-chip>

        <svc-chip-grouped
          *ngIf="filter.type == 'chip-grouped'"
          [svcTestId]="filter.svcTestId"
          class="w-full"
          [label]="filter.label"
          [formControl]="controls[index]"
          [options]="filter.config?.options"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
          [showCheckbox]="filter.config?.showCheckbox"
        ></svc-chip-grouped>

        <div *ngIf="filter.type == 'toggle'" [svcTestId]="filter.svcTestId" class="w-full">
          <div *ngIf="filter.label" class="input-label-size input-label-weight text-default mb-1.5">
            {{ filter.label }}
          </div>
          <svc-slide-toggle [formControl]="controls[index]" [inputId]="filter?.id ?? 'filters-field-'+filter.name"></svc-slide-toggle>
        </div>

        <svc-select-period
          class="w-full"
          *ngIf="filter?.type == 'select-period'"
          [svcTestId]="filter.svcTestId"
          [label]="filter?.label"
          [formControl]="controls?.[index]"
          [min]="filter?.config?.minDate"
          [max]="filter?.config?.maxDate"
          [useFirstMondayRule]="useFirstMondayRule"
          [format]="filter?.config?.format"
          [inputId]="filter?.id ?? 'filters-field-'+filter.name"
        >
        </svc-select-period>

        <svc-date-picker-range
          *ngIf="filter.type == 'date-range'"
          [svcTestId]="filter.svcTestId"
          [label]="filter.label"
          [formControl]="controls?.[index]"
          [min]="filter?.config?.minDate"
          [max]="filter?.config?.maxDate"
          [format]="filter?.config?.format"
        ></svc-date-picker-range>
      </ng-template>
